import {useEffect, useState} from 'react';
import config from '../../../oktaConfig';
import {useOktaAuth} from '@okta/okta-react';
import DeviceResponse from '../interfaces/DeviceResponse';

export default function useDevice(siteId: string) {
  const {authState, oktaAuth} = useOktaAuth();
  const [data, setData] = useState<DeviceResponse[] | null>(null);
  const [pending, setPending] = useState<boolean>(true);
  const [dataLoaded, setDataLoaded] = useState<boolean>(false);

  useEffect(() => {
    async function fetchDevices(
      accessToken: string | undefined,
      siteId: string,
      controller: AbortController
    ) {
      let response = await fetch(
        config.resourceServer.insightsApiUrlDevices + `?siteId=${siteId}&deviceType=switch`,
        {
          mode: 'cors',
          credentials: 'include',
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          signal: controller.signal,
        }
      );

      if (!response.ok) return Promise.reject(response);

      setData((await response.json()) as DeviceResponse[]);
      setPending(false);
      setDataLoaded(true);
    }

    if (authState && authState.isAuthenticated && siteId) {
      const accessToken = oktaAuth.getAccessToken();
      const controller = new AbortController();
      setData(null);
      setPending(true);
      setDataLoaded(false);
      fetchDevices(accessToken, siteId, controller);

      return () => {
        controller.abort();
        setData(null);
        setPending(true);
      };
    } else {
      setData(null);
      setPending(true);
      setDataLoaded(false);
    }
  }, [siteId, authState, oktaAuth]);

  return {data, pending, dataLoaded};
}
